import { useLang } from "../lang";
import { company } from "../data";

const field = "mt-1 w-full rounded-md border border-steel-200 bg-white px-3 py-2.5 focus:border-gws-blue focus:outline-none focus:ring-2 focus:ring-gws-blue/30";

function Contactpage() {
  const { t } = useLang();

  // ponytail: no backend, so the form opens the visitor's mail app. Add a form service if leads go missing.
  const send = (e) => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target));
    const body = `${f.message}\n\n${f.name}\n${f.phone}`;
    window.location.href = `mailto:${company.email}?subject=${encodeURIComponent(`[gws-rd.com] ${f.name}`)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <section className="bg-white">
        <div className="wrap grid gap-12 py-12 md:grid-cols-2 md:py-16">
          <div>
            <h1 className="text-3xl font-bold md:text-5xl">{t("ติดต่อเรา", "Contact us")}</h1>
            <p className="mt-4 text-lg text-ink-soft">{t("ปรึกษาฟรี โทรหรือส่งรายละเอียดไลน์ผลิตมาได้เลย", "Consultation is free. Call us or send details of your line.")}</p>
            <dl className="mt-8 space-y-5">
              <div>
                <dt className="text-sm text-steel-600">{t("โทรศัพท์", "Phone")}</dt>
                <dd><a href={`tel:${company.tel}`} className="text-2xl font-bold hover:text-gws-blue">{company.phone}</a></dd>
              </div>
              <div>
                <dt className="text-sm text-steel-600">{t("อีเมล", "Email")}</dt>
                <dd><a href={`mailto:${company.email}`} className="break-all text-lg font-semibold hover:text-gws-blue">{company.email}</a></dd>
              </div>
              <div>
                <dt className="text-sm text-steel-600">Facebook</dt>
                <dd><a href={company.facebook} target="_blank" rel="noreferrer" className="text-lg font-semibold hover:text-gws-blue">GWS Research & Development</a></dd>
              </div>
              <div>
                <dt className="text-sm text-steel-600">{t("ที่อยู่", "Address")}</dt>
                <dd className="text-lg">{t(company.name)}<br />{t(company.address)}</dd>
              </div>
            </dl>
          </div>

          <form onSubmit={send} className="rounded-lg border border-steel-200 bg-steel-50 p-6">
            <h2 className="text-xl font-semibold">{t("ส่งรายละเอียดงาน", "Send project details")}</h2>
            <label className="mt-5 block font-medium">
              {t("ชื่อ-นามสกุล / บริษัท", "Name / company")}
              <input name="name" required autoComplete="name" className={field} />
            </label>
            <label className="mt-4 block font-medium">
              {t("เบอร์โทรศัพท์", "Phone")}
              <input name="phone" type="tel" required autoComplete="tel" className={field} />
            </label>
            <label className="mt-4 block font-medium">
              {t("รายละเอียด (สินค้า กำลังการผลิต ปัญหาที่อยากแก้)", "Details (product, output, problem to solve)")}
              <textarea name="message" rows="5" required className={field} />
            </label>
            <button type="submit" className="btn-primary mt-6 w-full">{t("ส่งทางอีเมล", "Send by email")}</button>
          </form>
        </div>
      </section>

      <section className="wrap py-12">
        <iframe
          title={t("แผนที่", "Map")}
          src={company.map}
          className="h-[60vh] min-h-[320px] w-full rounded-lg border border-steel-200"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <a href={company.mapLink} target="_blank" rel="noreferrer" className="mt-3 inline-block font-semibold text-gws-blue hover:underline">
          {t("เปิดใน Google Maps →", "Open in Google Maps →")}
        </a>
      </section>
    </>
  );
}

export default Contactpage;
